
import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  getSetmealPage,
  deleteSetmeal,
  setmealStatusByStatus,
  setmealHomeDisplay,
  setmealFlashSale,
  setmealSetSort
} from '@/api/setMeal'
import Empty from '@/components/Empty/index.vue'
import SortInlineEdit from '@/components/SortInlineEdit/index.vue'
import { UserModule } from '@/store/modules/user'
import { listMyStores } from '@/api/store'
import { STORE_CONTEXT_EVENT } from '@/utils/storeContext'

@Component({
  name: 'PromoSetmeal',
  components: {
    Empty,
    SortInlineEdit
  }
})
export default class extends Vue {
  private input: any = ''
  private counts: number = 0
  private page: number = 1
  private pageSize: number = 10
  private checkList: any[] = []
  private tableData: any[] = []
  private dishStatus: any = ''
  private homeDisplay: any = ''
  private isSearch: boolean = false
  private storeOptions: Array<{ id: number; name: string }> = []
  private saleStatus: any = [
    { value: 0, label: '下架' },
    { value: 1, label: '上架' }
  ]

  get currentStoreId() {
    const sid = UserModule.storeId
    if (!sid) return null
    const n = Number(sid)
    return Number.isNaN(n) ? null : n
  }

  get currentStoreLabel(): string {
    const sid = this.currentStoreId
    if (sid == null) return '未选择商户'
    const found = this.storeOptions.find((s) => Number(s.id) === Number(sid))
    return found ? found.name : `商户${sid}`
  }

  @Watch('currentStoreId')
  private onStoreChange() {
    this.page = 1
    this.init()
  }

  created() {
    this.loadStores()
    this.init()
    window.addEventListener(STORE_CONTEXT_EVENT, this.onStoreEvent as any)
  }

  beforeDestroy() {
    window.removeEventListener(STORE_CONTEXT_EVENT, this.onStoreEvent as any)
  }

  private onStoreEvent() {
    this.page = 1
    this.init()
  }

  private async loadStores() {
    try {
      const res: any = await listMyStores()
      if (String(res.data.code) === '1' && Array.isArray(res.data.data)) {
        this.storeOptions = res.data.data.map((it: any) => ({
          id: it.id,
          name: it.storeName || it.name || `商户${it.id}`
        }))
      }
    } catch (e) {
      this.storeOptions = []
    }
  }

  initFun() {
    this.page = 1
    this.init()
  }

  private async init(isSearch?) {
    this.isSearch = !!isSearch
    const storeId = this.currentStoreId
    if (!storeId) {
      this.tableData = []
      this.counts = 0
      return
    }
    await getSetmealPage({
      page: this.page,
      pageSize: this.pageSize,
      name: this.input || undefined,
      status: this.dishStatus === '' ? undefined : this.dishStatus,
      homeDisplay: this.homeDisplay === '' ? undefined : this.homeDisplay,
      storeId
    })
      .then((res) => {
        const body = (res && res.data) || {}
        if (String(body.code) === '1' && body.data) {
          this.tableData = body.data.records || []
          this.counts = Number(body.data.total) || 0
        } else {
          this.tableData = []
          this.counts = 0
          this.$message.error(body.msg || '获取特惠套餐列表失败')
        }
      })
      .catch((err) => {
        this.tableData = []
        this.counts = 0
        this.$message.error('请求出错了：' + err.message)
      })
  }

  private addSetMeal(st: any) {
    if (st === 'add') {
      this.$router.push({ path: '/setmeal/add' })
    } else {
      this.$router.push({ path: '/setmeal/add', query: { id: st.id } })
    }
  }

  private async onHomeDisplaySwitch(row: any, on: boolean) {
    if (!row || !row.id) return
    const next: 0 | 1 = on ? 1 : 0
    const prev = Number(row.homeDisplay) === 1 ? 1 : 0
    if (next === prev) return
    this.$set(row, 'homeDisplay', next)
    try {
      const res: any = await setmealHomeDisplay({ id: row.id, homeDisplay: next })
      if (res && res.data && String(res.data.code) === '1') {
        this.$message.success(next === 1 ? '已开启首页展示（并已上架）' : '已关闭首页展示')
        this.init()
      } else {
        this.$set(row, 'homeDisplay', prev)
        this.$message.error((res.data && res.data.msg) || '操作失败')
      }
    } catch (err: any) {
      this.$set(row, 'homeDisplay', prev)
      this.$message.error('请求出错了：' + ((err && err.message) || '未知错误'))
    }
  }

  private async onFlashSaleSwitch(row: any, on: boolean) {
    if (!row || !row.id) return
    const next: 0 | 1 = on ? 1 : 0
    const prev = Number(row.flashSale) === 1 ? 1 : 0
    if (next === prev) return
    this.$set(row, 'flashSale', next)
    try {
      const res: any = await setmealFlashSale({ id: row.id, flashSale: next })
      if (res && res.data && String(res.data.code) === '1') {
        this.$message.success(
          next === 1 ? '已开启限时抢购（截止默认七天后，并已上架）' : '已关闭限时抢购'
        )
        this.init()
      } else {
        this.$set(row, 'flashSale', prev)
        this.$message.error((res.data && res.data.msg) || '操作失败')
      }
    } catch (err: any) {
      this.$set(row, 'flashSale', prev)
      this.$message.error('请求出错了：' + ((err && err.message) || '未知错误'))
    }
  }

  private setSortHandle(row: any, sort: number) {
    if (!row || !row.id) return
    const storeId = this.currentStoreId
    if (!storeId) {
      this.$message.warning('请先在顶栏选择商户')
      return
    }
    setmealSetSort({ id: row.id, sort, storeId })
      .then((res: any) => {
        if (res && res.data && String(res.data.code) === '1') {
          this.$message.success('排序已更新')
          this.init()
        } else {
          this.$message.error((res.data && (res.data.msg || res.data.desc)) || '排序失败')
        }
      })
      .catch((err: any) => {
        this.$message.error('请求出错了：' + ((err && err.message) || '未知错误'))
      })
  }

  private deleteHandle(type: string, id: any = null) {
    if (type === '批量' && id === null) {
      if (this.checkList.length === 0) {
        return this.$message.error('请选择删除对象')
      }
    }
    this.$confirm('确定删除该特惠套餐?', '确定删除', {
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      deleteSetmeal(type === '批量' ? this.checkList.join(',') : id)
        .then((res) => {
          if (res.data.code === 1) {
            this.$message.success('删除成功！')
            this.init()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  private statusHandle(row: any) {
    const params: any = {
      ids: row.id,
      status: row.status == '0' ? 1 : 0
    }
    this.$confirm(`确认${row.status == '0' ? '启售' : '停售'}该特惠套餐?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      setmealStatusByStatus(params)
        .then((res) => {
          if (String(res.data.code) === '1') {
            this.$message.success('操作成功！')
            this.init()
          } else {
            this.$message.error(res.data.msg || '操作失败')
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  handleSelectionChange(val: any[]) {
    this.checkList = val.map((item) => item.id)
  }

  private handleSizeChange(val: any) {
    this.pageSize = val
    this.init()
  }

  private handleCurrentChange(val: any) {
    this.page = val
    this.init()
  }

  /** 列表展示抢购截止时间 */
  private formatFlashEndTime(val: any): string {
    if (val == null || val === '') return '—'
    if (typeof val === 'string') {
      return val.length >= 19 ? val.slice(0, 19).replace('T', ' ') : val
    }
    try {
      const d = new Date(val)
      if (Number.isNaN(d.getTime())) return '—'
      const pad = (n: number) => (n < 10 ? `0${n}` : String(n))
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    } catch (e) {
      return '—'
    }
  }
}
